export default function TicketHeader() {
  return (
    <div>
      {/* Header with name and contact button */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-normal">Farukh Zaman</h1>
        <button className="bg-[#036494] text-white px-7 py-2 rounded-full text-sm font-light  transition-colors">
          Contact Client
        </button>
      </div>

      {/* Info grid header */}
      <div className="grid grid-cols-8 gap-4 text-sm text-[#1E1E1E] mb-2 font-medium">
        <div>Contact Name</div>
        <div>App Date</div>
        <div>Phone No.</div>
        <div>From</div>
        <div>Application</div>
        <div>Status</div>
        <div>Country</div>
        <div>Missing Documents</div>
      </div>

      {/* Client info card */}
      <div className="rounded-lg p-4 bg-[#FFFBF5] border border-[#CAC3BB] text-sm">
        <div className="grid grid-cols-8 gap-4 items-center">
          <div>
            Farukh
            <br />
            Zaman
          </div>
          <div>
            04/01/25
          </div>
          <div>
            +92 323 998 746
          </div>
          <div>
            Rwp, Pakistan
          </div>
          <div>
            Study Visa
          </div>
          <div>In Process</div>
          <div>Australia</div>
          <div className="text-red-500">IELTS Results</div>
        </div>
      </div>
    </div>
  )
}

